import React,{lazy,Suspense} from 'react';
import {TeamProvider} from '../../context/TeamContext';
import {WorkspaceFeature} from '../event-workspace/EventWorkspace';
import {useLibraryNativeTools} from './LibraryNativeContext';

const Upload=lazy(()=>import('../Review/UploadVideoModal'));
const Record=lazy(()=>import('../Review/LiveRecordModal'));
const Stats=lazy(()=>import('../../core-pages/team-stats/UploadScoreDialog'));

export default function LibraryDialogs({action,onClose,onSaved}){
  const native=useLibraryNativeTools();
  if(!action)return null;
  return <TeamProvider selectedTeamId={action.teamId}><Suspense fallback={<p role="status">Opening recording tools… <button type="button" className="app-cancel-control" onClick={onClose}>Cancel</button></p>}>
    <WorkspaceFeature teamId={action.teamId} feature={action.kind==='stats'?'teamStats':'vodReviewer'} onClose={onClose}>
      {action.kind==='import'?(native?.Upload?<native.Upload teamId={action.teamId} mapId={action.mapId||''} onClose={onClose} onSaved={onSaved}/>:<Upload teamId={action.teamId} mapId={action.mapId||''} onClose={onClose} onVideoUploaded={onSaved}/>):action.kind==='record'?<Record mapId={action.mapId||''} onClose={onClose} onVideoUploaded={onSaved}/>:<Stats teamId={action.teamId} onClose={onClose} onSaved={onSaved}/>}
    </WorkspaceFeature>
  </Suspense></TeamProvider>;
}
